/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { RunBeamConstancyMeasurementRequestDto } from './RunBeamConstancyMeasurementRequestDto';
import {
    instanceOfRunBeamConstancyMeasurementRequestDto,
    RunBeamConstancyMeasurementRequestDtoFromJSON,
    RunBeamConstancyMeasurementRequestDtoFromJSONTyped,
    RunBeamConstancyMeasurementRequestDtoToJSON,
} from './RunBeamConstancyMeasurementRequestDto';
import type { RunReferenceMeasurementRequestDto } from './RunReferenceMeasurementRequestDto';
import {
    instanceOfRunReferenceMeasurementRequestDto,
    RunReferenceMeasurementRequestDtoFromJSON,
    RunReferenceMeasurementRequestDtoFromJSONTyped,
    RunReferenceMeasurementRequestDtoToJSON,
} from './RunReferenceMeasurementRequestDto';
import type { RunReferenceMeasurementRequestInJobOccurrenceDto } from './RunReferenceMeasurementRequestInJobOccurrenceDto';
import {
    instanceOfRunReferenceMeasurementRequestInJobOccurrenceDto,
    RunReferenceMeasurementRequestInJobOccurrenceDtoFromJSON,
    RunReferenceMeasurementRequestInJobOccurrenceDtoFromJSONTyped,
    RunReferenceMeasurementRequestInJobOccurrenceDtoToJSON,
} from './RunReferenceMeasurementRequestInJobOccurrenceDto';
import type { RunZeroMeasurementRequestDto } from './RunZeroMeasurementRequestDto';
import {
    instanceOfRunZeroMeasurementRequestDto,
    RunZeroMeasurementRequestDtoFromJSON,
    RunZeroMeasurementRequestDtoFromJSONTyped,
    RunZeroMeasurementRequestDtoToJSON,
} from './RunZeroMeasurementRequestDto';

/**
 * @type RunMeasurementRequestDto
 * 
 * @export
 */
export type RunMeasurementRequestDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.MeasurementComponent.Dto.RunZeroMeasurementRequestDto, Ptw.Ptw100.AppZero.Application.Shared' } & RunZeroMeasurementRequestDto | { $type?: 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunBeamConstancyMeasurementRequestDto, Ptw.Ptw100.BeamConstancyCheck.Application' } & RunBeamConstancyMeasurementRequestDto | { $type?: 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunReferenceMeasurementRequestDto, Ptw.Ptw100.BeamConstancyCheck.Application' } & RunReferenceMeasurementRequestDto | { $type?: 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunReferenceMeasurementRequestInJobOccurrenceDto, Ptw.Ptw100.BeamConstancyCheck.Application' } & RunReferenceMeasurementRequestInJobOccurrenceDto;


export function RunMeasurementRequestDtoFromJSON(json: any): RunMeasurementRequestDto {
    return RunMeasurementRequestDtoFromJSONTyped(json, false);
}

export function RunMeasurementRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunMeasurementRequestDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MeasurementComponent.Dto.RunZeroMeasurementRequestDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, RunZeroMeasurementRequestDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.MeasurementComponent.Dto.RunZeroMeasurementRequestDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunBeamConstancyMeasurementRequestDto, Ptw.Ptw100.BeamConstancyCheck.Application':
            return Object.assign({}, RunBeamConstancyMeasurementRequestDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunBeamConstancyMeasurementRequestDto, Ptw.Ptw100.BeamConstancyCheck.Application' } as const);
        case 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunReferenceMeasurementRequestDto, Ptw.Ptw100.BeamConstancyCheck.Application':
            return Object.assign({}, RunReferenceMeasurementRequestDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunReferenceMeasurementRequestDto, Ptw.Ptw100.BeamConstancyCheck.Application' } as const);
        case 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunReferenceMeasurementRequestInJobOccurrenceDto, Ptw.Ptw100.BeamConstancyCheck.Application':
            return Object.assign({}, RunReferenceMeasurementRequestInJobOccurrenceDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunReferenceMeasurementRequestInJobOccurrenceDto, Ptw.Ptw100.BeamConstancyCheck.Application' } as const);
        default:
            throw new Error(`No variant of RunMeasurementRequestDto exists with '$type=${json['$type']}'`);
    }
}

export function RunMeasurementRequestDtoToJSON(value?: RunMeasurementRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.MeasurementComponent.Dto.RunZeroMeasurementRequestDto, Ptw.Ptw100.AppZero.Application.Shared':
            return RunZeroMeasurementRequestDtoToJSON(value);
        case 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunBeamConstancyMeasurementRequestDto, Ptw.Ptw100.BeamConstancyCheck.Application':
            return RunBeamConstancyMeasurementRequestDtoToJSON(value);
        case 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunReferenceMeasurementRequestDto, Ptw.Ptw100.BeamConstancyCheck.Application':
            return RunReferenceMeasurementRequestDtoToJSON(value);
        case 'Ptw.Ptw100.BeamConstancyCheck.Application.Measurement.RunReferenceMeasurementRequestInJobOccurrenceDto, Ptw.Ptw100.BeamConstancyCheck.Application':
            return RunReferenceMeasurementRequestInJobOccurrenceDtoToJSON(value);
        default:
            throw new Error(`No variant of RunMeasurementRequestDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the RunMeasurementRequestDto interface.
 */
export function instanceOfRunMeasurementRequestDto(value: any): value is RunMeasurementRequestDto {
    if (instanceOfRunZeroMeasurementRequestDto(value)) return true;
    if (instanceOfRunBeamConstancyMeasurementRequestDto(value)) return true;
    if (instanceOfRunReferenceMeasurementRequestDto(value)) return true;
    if (instanceOfRunReferenceMeasurementRequestInJobOccurrenceDto(value)) return true;
    return false;
}

